var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { Modal, Table, Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import api from '@/api';
const SelectContentModal = ({ visible, onOk, onCancel, initialSelectedItem, currentRecord, projectTech, }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [dataList, setDataList] = useState([]); // 用于存储接口返回的数据
    useEffect(() => {
        if (initialSelectedItem) {
            setSelectedRowKeys([initialSelectedItem.key]);
            setSelectedItem(initialSelectedItem);
        }
        else {
            setSelectedRowKeys([]);
            setSelectedItem(null);
        }
        //  && currentRecord?.content === 'TRANS'
        if (visible) {
            const getTRANSOptions = () => __awaiter(void 0, void 0, void 0, function* () {
                // 假设有一个新的 API 接口来获取 TRANS 相关的内容选项
                const res = yield api.CoachCardApi.getTREDeclaredDifficultyList({
                    eventphase_type1: projectTech,
                });
                if (res.data && res.data.code === 200) {
                    const clearOption = { key: 'clear', code: '--clear--', element: '', dd: '', description: 'Clear this difficulty' };
                    const formattedApiData = res.data.data.map((item, index) => (Object.assign(Object.assign({}, item), { key: item.code + item.dd + item.element + index })));
                    const newDataList = [clearOption, ...formattedApiData];
                    setDataList(newDataList);
                }
            });
            getTRANSOptions();
        }
        else {
            setDataList([]); // 如果不满足条件，清空数据
        }
    }, [initialSelectedItem, visible, currentRecord, projectTech]);
    const columns = [
        {
            title: '',
            dataIndex: 'code',
            key: 'code',
            width: 80,
            render: (value, record) => {
                return record.code + '' + ((record === null || record === void 0 ? void 0 : record.categoryCode) || '');
            }
        },
        {
            title: '',
            dataIndex: 'element',
            key: 'element',
            width: 100,
        },
        {
            title: '',
            dataIndex: 'dd',
            key: 'dd',
            width: 80,
        },
        {
            title: 'Clear this difficulty',
            dataIndex: 'description',
            key: 'description',
        },
    ];
    const rowSelection = {
        type: 'radio',
        selectedRowKeys,
        onChange: (keys, selectedRows) => {
            setSelectedRowKeys(keys);
            setSelectedItem(selectedRows.length > 0 ? selectedRows[0] : null);
        },
    };
    const handleOk = () => {
        onOk(selectedItem);
    };
    const handleCancel = () => {
        onCancel();
    };
    return (<Modal title="Select Content" open={visible} onOk={handleOk} onCancel={handleCancel} width="80%" bodyStyle={{ minHeight: '40vh', maxHeight: '60vh', overflowY: 'auto' }} footer={[
            <Button key="cancel" onClick={handleCancel} icon={<CloseOutlined />}>
          Cancel
        </Button>,
            <Button key="ok" type="primary" onClick={handleOk} icon={<CheckOutlined />}>
          OK
        </Button>,
        ]}>
      <Table rowKey={(record) => record.key} rowSelection={rowSelection} columns={columns} dataSource={dataList} pagination={false} bordered size="small" rowClassName={(record) => (selectedRowKeys.includes(record.key) ? 'ant-table-row-selected-custom' : '')} onRow={(record) => {
            return {
                onClick: () => {
                    // 直接调用 rowSelection 的 onChange
                    rowSelection.onChange([record.key], [record]);
                },
            };
        }}/>
    </Modal>);
};
export default SelectContentModal;
